/**
 * Default Data Schemas for Astrology Chart
 * Predefined schemas for common data paths
 */

import { DataSchema } from '../types/DataTypes';

/**
 * Default schemas for astrology chart data
 */
export const DEFAULT_SCHEMAS: Record<string, DataSchema> = {
    'chart.dimensions': {
        defaultValue: { width: 400, height: 400 },
        validator: (value) => {
            return value && typeof value.width === 'number' && typeof value.height === 'number';
        },
        description: 'Chart dimensions in pixels'
    },

    'chart.zoom': {
        defaultValue: 1.0,
        validator: (value) => typeof value === 'number' && value > 0 && value <= 50,
        description: 'Current zoom level'
    },

    'chart.visibility': {
        defaultValue: true,
        validator: (value) => typeof value === 'boolean',
        description: 'Chart visibility state'
    },

    'layout.activeLayout': {
        defaultValue: 'rasi-D1-v2',
        validator: (value) => typeof value === 'string' && value.length > 0,
        description: 'Currently active layout ID'
    },

    'modifiers.activeModifiers': {
        defaultValue: [],
        validator: (value) => Array.isArray(value),
        description: 'List of active modifier IDs'
    },

    'user.preferences': {
        defaultValue: {
            theme: 'default',
            language: 'en',
            animations: true
        },
        description: 'User preferences'
    },

    'performance.metrics': {
        defaultValue: {
            renderTime: 0,
            memoryUsage: 0,
            eventCount: 0
        },
        readonly: true,
        description: 'Performance metrics (readonly)'
    }
};

/**
 * Initialize default schemas in a data context
 */
export function initializeDefaultSchemas(defineSchema: (path: string, schema: DataSchema) => void): void {
    Object.entries(DEFAULT_SCHEMAS).forEach(([path, schema]) => {
        defineSchema(path, schema);
    });
}
